<ul class="filters-status-subsection">
    <li *ngFor="let status of available" (click)="onSelect(status)" [ngStyle]="{ 'background-color': status.status.color }">
        <span class="filter-subtitle" >{{status.status.name}}</span>
    </li>
</ul>
